/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

export const GET_STORE_COOLER_PLANS = gql`
  query GetStoreCoolerPlans($storeId: ID!) {
    storeCoolerPlans(storeId: $storeId) {
      displayId
      displayName
      displayOrder
      thumbnailUrl
    }
  }
`
